import axios from "axios";

export async function postData(obj) {
  return await axios.post(`/report/update-scores`, obj);
}

export async function getData(reportName, grade) {
  return await axios.get(`/report/by-grade/${reportName}/${grade}`);
}